import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from "react";

function cx(...classes: Array<string | undefined | false>): string {
  return classes.filter(Boolean).join(" ");
}

export function SacredCard({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement> & { children: ReactNode }) {
  return (
    <div className={cx("card-sacred", className)} {...props}>
      {children}
    </div>
  );
}

export function WarmDivider({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx("divider-warm", className)} {...props} />;
}

export function sacredButtonClassName(className?: string): string {
  return cx("btn-sacred", className);
}

export function SacredButton({
  className,
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { children: ReactNode }) {
  return (
    <button className={sacredButtonClassName(className)} {...props}>
      {children}
    </button>
  );
}
